import React from "react";
import { Skeleton } from "src/assets/imports/antdComponents";

const ProfileContextSkeleton: React.FC = () => {
	return (
		<div style={{ width: "100%", maxWidth: "75rem", paddingTop: "2rem" }}>
			{/* Label */}
			<Skeleton.Input active style={{ width: 160, height: 20, marginBottom: 12 }} />

			{/* Large Textarea */}
			<Skeleton.Input
				active
				block
				style={{
					width: "100%",
					height: "calc(100vh - 35rem)",
					borderRadius: 8,
					marginBottom: 8,
				}}
			/>

			{/* Footer Buttons */}
			<div className="flex justify-end space-x-4 mt-8">
				<Skeleton.Button active style={{ width: 100, height: 40 }} />
				<Skeleton.Button active style={{ width: 120, height: 40 }} />
			</div>
		</div>
	);
};

export default React.memo(ProfileContextSkeleton);
